export default __webpack_public_path__ + "static/media/success_icon.cb074007.svg";